import React from "react";
import { FaCaretLeft, FaCaretRight } from "react-icons/fa";

interface ScrollbarProps {
  currentPage: number;
  totalPages: number;
  itemsPerPage: number;
  totalItems: number;
  onPrevPageClick: () => void;
  onNextPageClick: () => void;
  disableNext?: boolean;
  disablePrev?: boolean;
}

const Scrollbar: React.FC<ScrollbarProps> = ({
  currentPage,
  totalPages,
  itemsPerPage,
  totalItems,
  onPrevPageClick,
  onNextPageClick,
  disableNext,
  disablePrev,
}) => {
  const isFirstPage = currentPage === 1;
  const isLastPage = currentPage === totalPages;

  return (
    <div className="flex justify-end items-center  bg-[#88087B] py-5 px-2 text-[#F7F7F7] font-roboto text-xs font-medium leading-normal rounded-b-lg mt-10">
      <p>{`${(currentPage - 1) * itemsPerPage + 1} - ${Math.min(
        currentPage * itemsPerPage,
        totalItems
      )} of ${totalItems}`}</p>
      <button onClick={onPrevPageClick} disabled={disablePrev}>
        <FaCaretLeft
          size={30}
          className={`text-[#fff] cursor-pointer ${
            isFirstPage ? "opacity-50" : ""
          }`}
        />
      </button>
      <button onClick={onNextPageClick} disabled={disableNext}>
        <FaCaretRight
          size={30}
          className={`text-[#fff] cursor-pointer ${
            isLastPage ? "opacity-50" : ""
          }`}
        />
      </button>
    </div>
  );
};

export default Scrollbar;
